import { render, staticRenderFns } from "./flexcolForm.vue?vue&type=template&id=2869ea38&scoped=true"
import script from "./flexcolForm.vue?vue&type=script&lang=js"
export * from "./flexcolForm.vue?vue&type=script&lang=js"
import style0 from "./flexcolForm.vue?vue&type=style&index=0&id=2869ea38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869ea38",
  null
  
)

export default component.exports